
import React from 'react';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { useListingForm } from '@/context/ListingFormContext';
import CitySelect from '@/components/ui/CitySelect';

const ListingLocationSection = () => {
  const { formData, handleInputChange } = useListingForm();

  const handleCountryChange = (value: string) => {
    handleInputChange('country', value);
    // Reset location when country changes
    handleInputChange('location', '');
  };

  return (
    <>
      <div className="mb-4">
        <Label htmlFor="country" className="block text-sm font-medium text-gray-700 dark:text-gray-300">
          Shteti
        </Label>
        <Select value={formData.country} onValueChange={handleCountryChange}>
          <SelectTrigger id="country" className="w-full mt-1">
            <SelectValue placeholder="Zgjidhni shtetin" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="albania">Shqipëri</SelectItem>
            <SelectItem value="kosovo">Kosovë</SelectItem>
          </SelectContent>
        </Select>
      </div>
      
      <div className="mb-4">
        <CitySelect
          value={formData.location}
          onValueChange={(value) => handleInputChange('location', value)}
          label="Vendndodhja"
          placeholder="Zgjidhni qytetin"
          country={formData.country}
        />
      </div>
    </>
  );
};

export default ListingLocationSection;
